import { cx } from '@linaria/core';
import { useRef } from 'react';
import { TaskInput } from './atom.input.js';
import { useHigherThanViewport } from './hook.higher-than-viewport.js';
import { tokens, contentWrapper, wrapper, modifiers, contextWrapper, contextContentWrapper, inputsWrapper, inputsContentWrapper } from './molecule.task.style.js';
import { richtextStyles } from './shared.richtext.style.js';
import { jsx, jsxs, Fragment } from 'react/jsx-runtime';
import { useHTMLContent } from '../ast/util.print-html.js';

function TaskSection(props) {
  const rootRef = useRef(null);
  const inputsContentRef = useRef(null);
  const contextContentRef = useRef(null);

  // we should only limit the width of the context or inputs in case both are
  // available, otherwise they should simply fill the available space
  const hasInputsAndContext = !!props.task.guide && props.task.inputs.length > 0;
  const contextWidth = (() => {
    if (props.task.inputs.length === 0) {
      return 100;
    }
    if (props.task.guideFieldWidth === "auto" || !props.task.guideFieldWidth) {
      return 50;
    }
    if (props.task.guideFieldWidth <= 40) {
      return 35;
    } else if (props.task.guideFieldWidth >= 60) {
      return 65;
    } else {
      return 50;
    }
  })();
  const inputsWidth = (() => {
    if (!props.task.guide) {
      return 100;
    }
    return 100 - contextWidth;
  })();
  const inputsLongerThanViewport = useHigherThanViewport(inputsContentRef);
  const contextLongerThanViewport = useHigherThanViewport(contextContentRef);
  return /*#__PURE__*/jsx("div", {
    ref: rootRef,
    className: cx(wrapper, hasInputsAndContext && modifiers.hasContextAndTask.className, inputsLongerThanViewport && modifiers.inputsLongerThanViewport.className, contextLongerThanViewport && modifiers.contextLongerThanViewport.className),
    "data-flow": ["top", "bottom"].includes(props.task.alignment) ? "vertical" : "horisontal",
    children: /*#__PURE__*/jsx("div", {
      className: contentWrapper,
      style: tokens.__override({
        contextWidth: `${contextWidth}%`,
        inputsWidth: `${inputsWidth}%`
      }),
      children: ["top", "left"].includes(props.task.alignment) ? /*#__PURE__*/jsxs(Fragment, {
        children: [/*#__PURE__*/jsx(Context, {
          contextContentRef: contextContentRef,
          task: props.task
        }), /*#__PURE__*/jsx(Inputs, {
          ...props,
          inputsContentRef: inputsContentRef
        })]
      }) : /*#__PURE__*/jsxs(Fragment, {
        children: [/*#__PURE__*/jsx(Inputs, {
          ...props,
          inputsContentRef: inputsContentRef
        }), /*#__PURE__*/jsx(Context, {
          contextContentRef: contextContentRef,
          task: props.task
        })]
      })
    })
  });
}
function Context(props) {
  const context = useHTMLContent(props.task.guide);
  if (!props.task.guide) {
    return null;
  }
  return /*#__PURE__*/jsx("div", {
    className: contextWrapper,
    children: /*#__PURE__*/jsx("div", {
      ref: props.contextContentRef,
      className: cx(contextContentWrapper, richtextStyles),
      children: context
    })
  });
}
function Inputs(props) {
  if (props.task.inputs.length === 0) {
    return null;
  }
  return /*#__PURE__*/jsx("div", {
    className: inputsWrapper,
    children: /*#__PURE__*/jsx("div", {
      ref: props.inputsContentRef,
      className: inputsContentWrapper,
      children: props.task.inputs.map(input => /*#__PURE__*/jsx(TaskInput, {
        entryKey: props.component.entryKey,
        taskId: props.task.id,
        input: input,
        settings: props.component.data.settings
      }, `${props.task.id}-${input.id}`))
    })
  });
}

export { TaskSection };
//# sourceMappingURL=molecule.task.js.map
